import { AGENT_MODELS_ROUTE } from "@/components/organization/orgRoutes";

/**
 * Studio › Agents › Agent › Settings leaves (design/os-reorganisation-ecrans
 * § 3, lot R4): each leaf owns its route; none is a tab of another page.
 */
export const AGENT_SETTINGS_ROUTES = {
  tools: "/studio/mcp",
  connectors: "/studio/connectors",
  secrets: "/studio/variables",
  data: "/studio/data",
  models: AGENT_MODELS_ROUTE,
  keys: "/studio/api-keys",
  spaces: "/studio/spaces",
} as const;

/** Agent-scoped settings paths: they reveal the Agent's Settings folder. */
export const AGENT_SETTINGS_PATHS: string[] = Object.values(AGENT_SETTINGS_ROUTES);

/** Studio › Applications › App › Web (hosted frontend, application-web). */
export const APPLICATION_WEB_ROUTE = "/studio/web";

/**
 * Tools used to carry Connectors and Variables as tabs. A former
 * `?section=integrations|variables` deep-link now opens the dedicated leaf,
 * keeping every other parameter (runtime binding seed, Agent, organization).
 */
export function legacyToolsSectionTarget(search: string): string | null {
  const params = new URLSearchParams(search);
  const section = params.get("section");
  const target =
    section === "integrations"
      ? AGENT_SETTINGS_ROUTES.connectors
      : section === "variables"
        ? AGENT_SETTINGS_ROUTES.secrets
        : null;
  if (!target) return null;
  params.delete("section");
  const rest = params.toString();
  return rest ? `${target}?${rest}` : target;
}
